import api from '@/services/api'

const state = {
  current: { active: 0, indicators: [], charts: [], sites: [] },
}

// getters
const getters = {}

// actions
const actions = {
  edit({ commit }, data) {
    return new Promise((resolve) => {
      api().post('/customer/user', data).then((response) => {
        resolve(response.data)
      })
    })
  },
  get({ commit }, id) {
    return new Promise((resolve) => {
      api().post('/customer/user/' + id).then((response) => {
        //commit('user', response.data.data)
        resolve(response.data.data)
      })
    })
  },
  delete({ commit }, id) {
    return new Promise((resolve) => {
      api().post('/customer/user/' + id + '/delete').then((response) => {
        resolve()
      })
    })
  },
  toggle({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api().post('/customer/user/' + data.id + '/toggle').then(response => {
        resolve(response)
      });
    }, error => { });
  },
  checkTokenResetPassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/customer/user/check-token-reset-password', data).then(response => {
        resolve(response.data)
      }, (error) => {
        console.log(error)
        reject();
      })
    });
  },
  resetPassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      const username = data && data.username ? data.username : ''
      const redirectUrl = data && data.redirectUrl ? data.redirectUrl : ''

      api().post('/customer/user/' + username + '/send-reset?redirectUrl=' + encodeURIComponent(redirectUrl)).then(response => {
        resolve(response.data)
      }, (error) => {
        console.log(error)
        reject();
      })
    });
  },
  setPassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/customer/user/password-reset', data).then(response => {
        resolve(response)
      }, (error) => {
        console.log(error)
        reject();
      })
    });
  },
  listByCustomerGuid({ commit }, guid) {
    return new Promise((resolve, reject) => {
      api().post('/customer/' + guid + '/users').then(response => {
        resolve(response)
      }, (error) => {
        console.log(error)
        reject(error);
      })
    });
  },
  list({ commit }) {
    return new Promise((resolve, reject) => {
      api().post('/users').then(response => {
        resolve(response.data.data)
      }, (error) => {
        console.log(error)
        reject(error);
      })
    });
  },
  saveIndicator({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/user/indicator/save', data).then(response => {
        resolve(response)
      }, (error) => {
        console.log(error)
        reject();
      })
    });
  },
  removeIndicator({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/user/indicator/remove', data).then(response => {
        resolve(response)
      }, (error) => {
        console.log(error)
        reject();
      })
    });
  },
  sites({ commit }) {
    return new Promise((resolve) => {
      api().get('/customer/user/sites').then((response) => {
        resolve(response.data.data)
      })
    })
  },
}

// mutations
const mutations = {
  /*current (state, current) {
    state.current = current
  },*/
  reset(state) {
    state.current = { active: 0 }
  },
  indicators(state) {
    state.current
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js